import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loadIcon } from "utils/dynamicIconLoader";

const DynamicFontAwesomeIcon = ({ iconName, iconType = "solid", ...props }) => {
  const [icon, setIcon] = useState(null);
  
  useEffect(() => {
    loadIcon(iconName, iconType)
      .then(loadedIcon => setIcon(loadedIcon))
      .catch(err => console.error(err));
  }, [iconName, iconType]);

  if (!icon) return null; // oder ein Ladesymbol
  return <FontAwesomeIcon icon={icon} {...props} />;
};

export default DynamicFontAwesomeIcon;
